import React from 'react';
import { IconTrophy, IconLock } from './Icons';

/**
 * A single achievement badge (earned per completed course).
 * The visual design (color) comes from the badge's design mapping; the same
 * badge id can later be mapped to a richer custom design in the backend.
 */
const Badge = ({ badge, earned = false, showInfo = true }) => {
  return (
    <div
      className={`ac-bdg-card ${earned ? 'is-earned' : 'is-locked'}`}
      style={{ '--bdg-color': badge.color || '#6da7ed' }}
    >
      <span className="ac-bdg-disc">
        {earned ? <IconTrophy size={22} /> : <IconLock size={16} />}
      </span>
      {showInfo && (
        <span className="ac-bdg-info">
          <span className="ac-bdg-name">{badge.name}</span>
          {badge.description && <span className="ac-bdg-desc">{badge.description}</span>}
          {!earned && <span className="ac-bdg-status">Locked</span>}
        </span>
      )}
    </div>
  );
};

export default Badge;
